import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Race } from '@app/rest-client/faxe/models/race';
import { SessionKeys } from '@app/constants/session-keys';
import { SessionService } from '@app/services/session/session.service';
import { RaceFacadeService } from '@app/facade-services/race/race-facade.service';
import { filter, takeUntil } from 'rxjs/operators';
import { defined } from '@app/fremework/functions';

@Injectable({
  providedIn: 'root'
})
export class SelectedRaceService implements OnDestroy {
  private selectedRaceSubject = new BehaviorSubject<Race>(null);
  private unsubscribe$ = new Subject<void>();
  public selectedRace$: Observable<Race> = this.selectedRaceSubject.asObservable();
  selectedRaceGuid: string;

  constructor(private readonly sessionService: SessionService,
              private readonly raceFacadeService: RaceFacadeService) {
  }

  init() {
    const raceGuid = this.sessionService.get(SessionKeys.selectedRaceId);
    if (defined(raceGuid)) {
      this.setSelectedRaceGuid(raceGuid, false);
    }
  }

  private fetchRaceByRaceGuid(raceGuid: string) {
    this.raceFacadeService.fetchRaceByRaceGuid(
      raceGuid,
      'SelectedRaceService')
      .pipe(takeUntil(this.unsubscribe$), filter(_ => defined(_)))
      .subscribe(race => {
        this.selectedRaceSubject.next(race);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public setSelectedRaceGuid(raceGuid: string, clearRaceCookies: boolean): void {
    this.selectedRaceGuid = raceGuid;
    this.sessionService.set(SessionKeys.selectedRaceId, raceGuid);
    this.fetchRaceByRaceGuid(raceGuid);

    if (clearRaceCookies) {
      this.sessionService.remove(SessionKeys.selectedClasses);
      this.sessionService.remove(SessionKeys.selectedFences);
    }

  }

}
